import { useMemo } from 'react';
import { bindActionCreators, ActionCreator, ActionCreatorsMapObject } from '@reduxjs/toolkit';
import { useAppDispatch } from '@/hooks/redux';

export function useActionsLeg<T extends ActionCreatorsMapObject>(actions: T, deps?: any[]): T;

export function useActionsLeg<T extends ActionCreator<any>>(actions: T[], deps?: any[]): T[];

export function useActionsLeg(actions: any, deps: any[] = []) {
  const dispatch = useAppDispatch();

  return useMemo(() => {
    if (Array.isArray(actions)) {
      return actions.map(a => bindActionCreators(a, dispatch));
    }
    return bindActionCreators(actions, dispatch);
  }, [dispatch, ...deps]);
}

// New Approach
export function useActions<T extends ActionCreatorsMapObject>(
  actions: T,
  deps: React.DependencyList = [],
): T {
  const dispatch = useAppDispatch();

  return useMemo(() => bindActionCreators(actions, dispatch), [dispatch, ...deps]);
}

export default useActions;
